import { render, staticRenderFns } from "./RunRecordsLightweight.vue?vue&type=template&id=472c6b94&scoped=true&"
import script from "./RunRecordsLightweight.vue?vue&type=script&lang=js&"
export * from "./RunRecordsLightweight.vue?vue&type=script&lang=js&"
import style0 from "./RunRecordsLightweight.vue?vue&type=style&index=0&id=472c6b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c6b94",
  null
  
)

export default component.exports